export default __webpack_public_path__ + "static/media/correct-icon.6017453b.svg";